export {
  getConfiguration,
  resolveModuleAsync,
  resolveExtraBuildDependenciesAsync,
} from './android';
